import "./SubdivisionPage.scss";
import {
  ArrowRightIcon,
  ContentArea,
  GridRow,
  HeroBasic,
  GridPresetMainContent,
  GridPresetSidebar,
  ContactInfoCardBlock,
  PersonCardsBlock,
  StaffInfoCardBlock,
  HideFor,
  Link,
  OptimizelyEditProperty,
} from "/App.Components";
import { ContentAreaType } from "/Models/Generated/ContentAreaType";
import { SubdivisionPageProps } from "/Models/Generated/SubdivisionPageProps";
import { ContentAreaItemMargin } from "/Components/Shared/ContentAreaItem/ContentAreaItem";
import { FocusedLinksBlockProps } from "/Models/Generated/FocusedLinksBlockProps";

const SubDivisionPage = ({
  pageHero,
  contactInfo,
  contactInfoPropertyName,
  contactPersons,
  staffInfo,
  staffInfoPropertyName,
  sidebar,
}: SubdivisionPageProps) => {
  const mobileNavigationItems = (sidebar?.items ?? []).filter(
    (item) =>
      item.name === "FocusedLinksBlock" &&
      (item.component as FocusedLinksBlockProps | undefined)
        ?.showAsMobileNavigation,
  );

  const mobileNavigationLinks = (
    <div className="subdivision-page-norad__mobile-navigation-links">
      {mobileNavigationItems.map((item) => {
        const focusedLinks = item.component as FocusedLinksBlockProps;
        const links = [
          ...(focusedLinks.links ?? []),
          ...(focusedLinks.specialLinks ?? []),
        ];

        return (
          <ul key={item.blockId}>
            {links.map((link, index) => (
              <li key={`${item.blockId}-${index}`}>
                <Link
                  {...link}
                  isExternal={false}
                  iconPlacement="before"
                  icon={ArrowRightIcon}
                  size="x-small"
                  fixedIcon
                />
              </li>
            ))}
          </ul>
        );
      })}
    </div>
  );

  return (
    <div className="subdivision-page-norad">
      {pageHero && <HeroBasic {...pageHero} />}
      {mobileNavigationItems.length > 0 && (
        <HideFor desktop desktopMedium desktopLargeUp>
          <div className="subdivision-page-norad__mobile-navigation-links--top">
            <GridRow>
              <GridPresetMainContent>{mobileNavigationLinks}</GridPresetMainContent>
            </GridRow>
          </div>
        </HideFor>
      )}
      <GridRow>
        <GridPresetMainContent>
          <div className="subdivision-page-norad__main-content">
            <div
              id="staff-info"
              className="subdivision-page-norad__staff-info-anchor"
            >
              {contactPersons && <PersonCardsBlock {...contactPersons} />}
              {!contactPersons?.personCards?.length && (
                <OptimizelyEditProperty
                  propertyName={staffInfoPropertyName}
                  clientRender
                >
                  {staffInfo && <StaffInfoCardBlock {...staffInfo} />}
                </OptimizelyEditProperty>
              )}
            </div>
            <OptimizelyEditProperty
              propertyName={contactInfoPropertyName}
              clientRender
            >
              <a
                id="contact-info"
                className="subdivision-page-norad__contact-info-anchor"
                tabIndex={-1}
              >
                {contactInfo?.heading}
              </a>
              {contactInfo && (
                <ContactInfoCardBlock {...contactInfo} inlineLabels />
              )}
            </OptimizelyEditProperty>
          </div>
        </GridPresetMainContent>
        {(sidebar?.propertyName || ContentArea.HasContent(sidebar)) && (
          <GridPresetSidebar>
            <aside className="subdivision-page-norad__sidebar">
              <ContentArea
                {...sidebar}
                contentAreaType={ContentAreaType.OneThird}
                margin={ContentAreaItemMargin.Sidebar}
              />
            </aside>
          </GridPresetSidebar>
        )}
      </GridRow>
    </div>
  );
};

export default SubDivisionPage;
